<template>
    <v-dialog @keydown.left="goLeft"  @keydown.right="goRight" fullscreen @keydown.esc="hide" v-model="show" loading hide-overlay transition="dialog-bottom-transition" style="width: 100% !important; margin: 0; height: 100% !important;overflow-x:hidden !important;">

        <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="opacity:0.1 !important;">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

        </video>

        <v-card v-if="show" dark style="background:rgba(0,0,0,0.9)" >
            <v-toolbar   style="cursor:pointer;z-index: 1;position:relative;background: transparent;" dark >
                <v-btn icon dark @click="hide">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="this.$vuetify.breakpoint.mdAndUp">Hicards Pack</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn style="margin-left: -150px;" icon dark @click="goLeft">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-items style="width:400px;">
                    <v-list-item>
                        <v-list-item-avatar >
                            <v-img
                                    :src="'/api/images/cards/collections/'+pack_data.COLLECTION+'/example2.png'"
                            ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline">{{pack_data.NAME}}</v-list-item-title>
                            <v-list-item-subtitle>köpt genom {{pack_data.USER_NAME}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>


                    </v-list-item>

                </v-toolbar-items>
                <v-btn icon dark @click="goRight">
                    <v-icon>mdi-arrow-right</v-icon>
                </v-btn>


                <v-spacer></v-spacer>



                <v-progress-linear
                        v-if="loading"
                        style="position:absolute;bottom:0;left:0;"
                        color="teal"
                        height="10"
                        value="100"
                        striped
                        indeterminate
                ></v-progress-linear>

            </v-toolbar>





            <v-card
                    v-if="this.$vuetify.breakpoint.mdAndUp"
                    class="mx-auto"
                    width="716"
                    height="571"

            >
                <div style="position:absolute;width:100%;height:100%;z-index: 2;">
                    <v-row style="height:100%;" align="center" justify="center">
                        <v-col align="center" justify="center">
                            <v-btn transition="expand-x-transition" v-show="!opening" @click="openPack" tile block style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" large class="">
                                Öppna paket
                            </v-btn>
                        </v-col>
                    </v-row>

                </div>
                <video ref="pack_open_video" style="width:100%;height:100%;">


                    <source :src="video_source"/>
                </video>




            </v-card>


            <v-row style="">
                <v-col class="col-md-1" :style="{'z-index':index}" v-for="(card,index) in card_data" :key="index" style="width:200px;">

                    <CollectionCardStatic
                            v-if="card!==undefined && card.TYPE===0"
                            :data=card
                    ></CollectionCardStatic>
                    <ActionCardStatic
                            v-if="card!==undefined && card.TYPE===1"
                            :data=card
                            :editable=false
                            :pack_opening=true

                    ></ActionCardStatic>


                </v-col>



            </v-row>
        </v-card>









    </v-dialog>
</template>

<script>

    import CollectionCardStatic from '../components/CollectionCardStatic'
    import ActionCardStatic from '../components/ActionCardStatic'




    export default {
        name: "PackHolder",
        components: {CollectionCardStatic, ActionCardStatic},
        props:{
            "pack_data":Object,
            "show":Boolean

        },
        data(){
            return{
                loading:true,
                mobileShow:false,
                faded:"",
                isUsing:false,
                opening:false,
                action_cards:[],
                collection_cards:[],
                card_data:[],
                card_open_sounds:[new Audio('/api/sounds/card_show1.mp3'),new Audio('/api/sounds/card_show2.mp3'),new Audio('/api/sounds/card_show3.mp3')],
                card_epic:new Audio('/api/sounds/card_epic.wav'),
                card_legendary:new Audio('/api/sounds/card_legendary.wav'),
                pack_open_sound:new Audio('/api/sounds/open_pack.mp3'),
                volume:1


            }
        },
        methods: {
            hide:function(){
                this.mobileShow=false;
                this.faded="";
                this.isUsing=false;
                this.opening=false;
                this.action_cards=[];
                this.collection_cards=[];
                this.card_data=[];
                this.$emit("hide")
            },
            goLeft:function(){
                this.$emit("goLeft");
            },
            goRight:function(){
                this.$emit("goRight");
            },
            openPack:function(){
                let http = new XMLHttpRequest();

                http.withCredentials = true;
                let url = '/api/open_pack';
                let params="PACK_ID="+this.pack_data.PACK_ID;
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("error");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        let data=JSON.parse(http.response);
                        console.log(data.activity_cards);
                        self.action_cards=self.action_cards.concat(data.activity_cards);
                        self.collection_cards=self.collection_cards.concat(data.collection_cards);
                        self.animateOpen();





                    }

                };
                http.send(params);

            },

            animateOpen:function(){
                this.opening=true;
                this.$refs.pack_open_video.play();
                let self=this;
                this.pack_open_sound.play();
                for(let i=0;i<this.collection_cards.length;i++){
                    setTimeout(function(){
                        self.card_data.push(self.collection_cards[i]);
                        self.card_open_sounds[i%2].play();
                        if(self.collection_cards[i].RANK_VALUE===2){
                            self.card_epic.play();
                        }
                        else if(self.collection_cards[i].RANK_VALUE===3){
                            self.card_legendary.play();
                        }

                    }, 11100+(1500*i));
                }
                for(let i=0;i<this.action_cards.length;i++){
                    setTimeout(function(){
                        self.card_data.push(self.action_cards[i]);
                        self.card_open_sounds[i%2].play();
                        if(self.collection_cards[i].RANK===2){
                            self.card_epic.play();
                        }
                        else if(self.collection_cards[i].RANK===3){
                            self.card_legendary.play();
                        }

                    }, 17000+(1500*i));
                }
                this.$emit("done")

            }







        },
        mounted() {
            this.loading=false;


        },
        watch:{
        },
        computed:{
            video_source:function(){
                return `/api/images/cards/collections/${this.pack_data['COLLECTION']}/open_pack_video.webm`
            }

        }
    }
</script>

<style scoped>
    .fade-out {
        animation: fadeOut ease 5s;
        -webkit-animation: fadeOut ease 5s;
        -moz-animation: fadeOut ease 5s;
        -o-animation: fadeOut ease 5s;
        -ms-animation: fadeOut ease 5s;
    }
    @keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-moz-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-webkit-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-o-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-ms-keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
</style>
